module.exports = __webpack_public_path__ + "img/pop_xiazainaedu@2x.5b5aa558.png";